<template>
    <div>
        <h2 class="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-4">Documentos diligenciados {{ listDocumentosDiligenciados.length }}</h2>
        <div class="h-75">
            <div v-if="listDocumentosDiligenciados.length === 0" class="flex justify-center items-center h-full text-gray-500 dark:text-gray-400">
                No hay documentos diligenciados
            </div>
            <template v-else>
                <div v-for="item in listDocumentosDiligenciados" :key="item.cifoCodigo" class="border border-green-600 rounded-md p-2 my-1" >
                    <DocumentosColumn
                        :item="({ cofoCodigo: item.cifoCodigo, cofoNombre: item.cifoNombre, cofoTipoDocumento: item.cifoTipoDocumento, cofoEstado: 1 } as IConfDocjson)"
                    />
                </div>
            </template>
        </div>
    </div>
    <div>
        <h2 class="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-4">Documentos disponibles {{ listDocumentos.length }}</h2>
        <div class="h-75">
            <div v-if="listDocumentos.length === 0" class="flex justify-center items-center h-full text-gray-500 dark:text-gray-400">
                No hay documentos disponibles
            </div>
            <template v-else>
                <div v-for="item in listDocumentos" :key="item.cofoCodigo" class="border border-blue-600 rounded-md p-2 my-1 hover:bg-blue-100 cursor-pointer" @click="diligenciarDocumento(item)" >
                    <DocumentosColumn
                        :item="item"
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, onMounted, nextTick } from 'vue'
import type { IConfDocjson, IConfDocjsonparametros } from '@/modules/Configuracion/interfaces'
import DocumentosColumn from '@/modules/Configuracion/components/Documentos/DocumentosColumn.vue'
import { useDocumentosDiligenciar } from '@/modules/Configuracion/composables/useDocumentosDiligenciar'
import DocumentosDiligenciarModal from '@/modules/Configuracion/components/Documentos/DocumentosDiligenciarModal.vue'
import { useModal } from '@/modules/Core/composables/useModal'
import type { IDocumentoFirma } from '../../interfaces/IDocumento'
const slots = defineSlots<{
  firmasPadrebuttons: (item: { firma: IDocumentoFirma }) => unknown
}>()
const { openModal } = useModal()
const { cofoTipoDocumento, cofoSitioDiligencia = null, ciadId = null, cittId = null, coseId = null, cocuId = null, sinServicio = false, ciadTipoEstado = null, parametros } =  defineProps<{
  cofoTipoDocumento: string
  ciadId?: number
  cittId?: number
  coseId?: number | null
  cocuId?: number | null
  cofoSitioDiligencia?: string
  sinServicio?: boolean
  ciadTipoEstado?: string | null
  parametros: IConfDocjsonparametros[]
}>()
const coseIdReactivo = computed(() => coseId);
const cocuIdReactivo = computed(() => cocuId);
const { listDocumentosDiligenciados, listDocumentos, getDiligenciados, getDocumentos, setDocSeleccionado } = useDocumentosDiligenciar()

const diligenciarDocumento = async (item: IConfDocjson) => {
    setDocSeleccionado(null)
    await nextTick()
    for await (const reporte of item.reportes) {
        if(reporte.reporte && reporte.reporte.parametros) {
            for await (const parametro of reporte.reporte.parametros) {
                const parametroExtraido = parametros.find(p => p.cdjpNombre === parametro.corpNombre)
                if (parametroExtraido) {
                    parametro.valor = parametroExtraido.valor
                }
            }
        }
    }
    const newDocSeleccionado = { ...item, tablaId: (ciadId || cittId) as number, tablaOrigen: ciadId ? 'tbl_cita_admisiones' : 'tbl_cita_technologiassalud' }
    setDocSeleccionado(newDocSeleccionado)
    await nextTick()
    await openModal('form-diligenciar-documento', { onlyOne: false, component: DocumentosDiligenciarModal, props: { docSeleccionado: newDocSeleccionado }, slots: { firmabuttons: ({firma}: {firma: IDocumentoFirma}) => slots.firmasPadrebuttons ? slots.firmasPadrebuttons({firma}) : null } })
}
onMounted(async ()=>{
   listDocumentosDiligenciados.value = []
   await getDocumentos({ cofoTipoDocumento, cofoSitioDiligencia, coseId: coseIdReactivo.value, cocuId: cocuIdReactivo.value, sinServicio, ciadTipoEstado })
   if (ciadId || cittId) await getDiligenciados({ tablaId: (ciadId || cittId) as number, tablaOrigen: ciadId ? 'tbl_cita_admisiones' : 'tbl_cita_technologiassalud',  cofoTipoDocumento } )
})
</script>
